import React from 'react';
import Stars from 'components/stars/Stars';

import styles from './styles.module.scss';

export const UserPlans = () => {
  return (
    <div className={styles.checkoutAchieveBoxWrapper}>
      <div className={styles.checkoutAchieveBox}>
        <h3 className={styles.title}>Users love our plans</h3>
        <h6 className={styles.subTitle}>
          Here's what people are saying about Loóna
        </h6>
        <div className={styles.appReviewsWrapper}>
          <div className={styles.review}>
            <Stars />

            <div className={styles.reviewTitle}>
              <p>It has really changed my life</p>
              <p className={styles.reviewer}>Maxpup94</p>
            </div>
            <p className={styles.reviewDescription}>
              have really bad anxiety and this helps a lot :) thankyou haven’t
              slept like this in years
            </p>
          </div>

          <div className={styles.review}>
            <Stars />

            <div className={styles.reviewTitle}>
              <p>Loóna is a great self-help tool...</p>
              <p className={styles.reviewer}>lexirio</p>
            </div>
            <p className={styles.reviewDescription}>
              This app is the equivalent of a sitting next to a warm fire during
              a cold winter night
            </p>
          </div>

          <div className={styles.review}>
            <Stars />

            <div className={styles.reviewTitle}>
              <p>Eye-opening information...</p>
              <p className={styles.reviewer}>gigi10894</p>
            </div>
            <p className={styles.reviewDescription}>
              Excellent app no pain feel relax ed and really calm feeling sleep
              is coming I discovered loóna at a time in my life when I was
              extremely anxious and down. Loona helped me at night to stop from
              overthinking and immediately relax. I then came to look forward to
              laying in bed and listening to the stories that not only calmed me
              visually with the immersive escapes but ones that I could relate
              to and left me refreshed
            </p>
          </div>

          <div className={styles.review}>
            <Stars />

            <div className={styles.reviewTitle}>
              <p>Eye-opening information...</p>
              <p className={styles.reviewer}>Meia Ojeda</p>
            </div>
            <p className={styles.reviewDescription}>
              I struggle with anxiety, depression, & ADHD. My anxiety &
              hyperactivity gets worse at night, & Loóna has helped me put my
              mind to rest
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
